module.exports = __webpack_public_path__ + "img/kep9.9c369c68.jpg";